// Import Core
import React from 'react';
import styled from 'styled-components';
// Import Libraries
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { toSlug } from '../../utils/search/toSlug';

/* Styled Components */
const TwoColInfoCardStyles = styled.section`
	background: var(--white);
	padding: var(--global-padding);
	display: flex;
	flex-direction: column;
	gap: 24px;
  @media(max-width: 768px) {
		padding: var(--global-padding-mobile);
  }
	> div {
    background: var(--red-10);
    padding: 24px;
    display: flex;
    flex-direction: row;
    gap: 32px;
    justify-content: space-between;
    @media(max-width: 768px) {
      flex-direction: column;
      gap: 20px;
      padding: 20px;
    }
    .section-title {
      flex: 1;
      h3 {
        padding: 12px 0 8px;
      }
    }   
    .image-content {
      .gatsby-image-wrapper {
        width: 100%;
        img {
          height: 250px;
          width: auto;
          @media(max-width: 768px) {
            max-height: 200px;
            width: auto;
            margin: auto;
          }
        }
      }
    }
	}
`;

/* Render Component */
const TwoColInfoCard = ({ subheading, title, caption, addToAnchor, image }) => {
  return (
    <TwoColInfoCardStyles id={addToAnchor ? `anchor_${toSlug(title)}` : ''} className={`${addToAnchor && 'anchor-link'}`}>
      <h3 className=''>THE KIRKER DIFFERENCE</h3>
      <div>
        <div className='section-title'>
          {subheading &&
            <p className='tagline italic'>{subheading}</p>
          }
          <h3 className='alt'>{title}</h3>
          <p>{caption}</p>
        </div>
        {(image && image.asset) && (
          <div className='image-content'>
            <GatsbyImage
              image={getImage(image.asset)}
              alt='Kirker Holidays'
            />
          </div>
        )}
      </div>
    </TwoColInfoCardStyles>
  );
};

export default TwoColInfoCard;
